import { useApi } from '@/hooks/useApi';
import { IDashboardFilterPayload } from '../model/summary';

export const useDashboardSummary = () => {
  const RESOURCE = 'dashboard';

  const { sendBasicRequest } = useApi('report');

  /**
   *
   * @param payload
   * @returns
   */
  async function getDashboardShipment(payload: IDashboardFilterPayload) {
    try {
      const response = await sendBasicRequest(`/${RESOURCE}/shipments`, 'POST', payload);

      if (response?.message) throw new Error(response?.message);

      return response?.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  /**
   *
   * @param payload
   * @returns
   */
  async function getDashboardChart(payload: IDashboardFilterPayload) {
    try {
      const response = await sendBasicRequest(`/${RESOURCE}/chart`, 'POST', payload);

      if (response?.message) throw new Error(response?.message);

      return response?.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  /**
   *
   * @param payload
   * @returns
   */
  async function getDashboardDaily(payload: IDashboardFilterPayload) {
    try {
      const response = await sendBasicRequest(`/${RESOURCE}/daily`, 'POST', payload);

      if (response?.message) throw new Error(response?.message);

      return response?.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  /**
   *
   * @param payload
   * @returns
   */
  async function getDashboardTopOrder(payload: IDashboardFilterPayload) {
    try {
      const response = await sendBasicRequest(`/${RESOURCE}/top-orders`, 'POST', payload);

      if (response?.message) throw new Error(response?.message);

      return response?.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  return {
    getDashboardShipment,
    getDashboardChart,
    getDashboardDaily,
    getDashboardTopOrder,
  };
};

export default useDashboardSummary;
